import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Item, PetCheckInsDetail, YearData, } from './../../interfaces/report';

import { DataMappingService } from './../../services/data-mapping.service';
import { JsonDataService } from './../../services/json-data.service';
import { PetService } from '../../services/pet.service'
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-monthly-expenses-per-item',
  templateUrl: './monthly-expenses-per-item.component.html',
  styleUrls: ['./monthly-expenses-per-item.component.scss']
})
export class MonthlyExpensesPerItemComponent implements OnInit {
  petCheckInsDetail= {} as PetCheckInsDetail;
  selectedPetId = '';
  selectedPickUp: any;
  isLoading = false;
  pickUpUpdateData = new FormData();
  isSavingPickUp = false;
  public onClose= new Subject<boolean>();
  isPetCheckInsDetailLoaded = false;
  selectedYear = '';
  selectedMonth = '';
  isMonthlyExpensesPerItemLoaded = false;
  monthlyExpensesPerItem= [] as YearData[];
  filteredMonthlyExpensesPerItem= [] as Item[];
  totalMonthlyExpenses = 0;

  constructor(private formBuilder: FormBuilder,
    private petService: PetService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private dataMappingService: DataMappingService,
    private jsonDataService: JsonDataService,
  ) {}

  ngOnInit(): void {
    console.log(`MonthlyExpensesPerItemComponent, ngOnInit, this is monthly revenue per item modal`);
    console.log(`MonthlyExpensesPerItemComponent, selectedYear: ${this.selectedYear}, selectedMonth: ${this.selectedMonth}`);

    if (this.selectedYear && this.selectedMonth) {
      console.log(`MonthlyExpensePerItemComponent, selectedYear: ${this.selectedYear}, selectedMonth: ${this.selectedMonth}`);
      this.getMonthlyExpensesPerItem();
    }
  }

  // Get monthly expenses per item
  getMonthlyExpensesPerItem() {
    this.isMonthlyExpensesPerItemLoaded = false;
    this.petService.getMonthlyExpensesPerItem().subscribe({
      next: (response) => {
        console.log(`getMonthlyExpensesPerItem, response: ${JSON.stringify(response)}`);
        this.monthlyExpensesPerItem = response;
        this.filteredMonthlyExpensesPerItem = this.filterMonthlyExpensesPerItemByYearAndMonth(this.selectedYear, this.selectedMonth);
        console.log(`getMonthlyExpensesPerItem, filteredData: ${JSON.stringify(this.filteredMonthlyExpensesPerItem)}`);
        this.totalMonthlyExpenses = this.calculateTotalMonthly();
        console.log(`getMonthlyExpensesPerItem, totalMonthlyExpenses: ${JSON.stringify(this.totalMonthlyExpenses)}`);
        this.isMonthlyExpensesPerItemLoaded = true;
      },
      error: (error) => {
        this.isMonthlyExpensesPerItemLoaded = true;
        console.error(`getMonthlyExpensesPerItem, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of get monthly revenue per item

  // Filter monthly expenses per item by year and month
  filterMonthlyExpensesPerItemByYearAndMonth(year: string, month: string): Item[] {
    let filteredData: Item[] = [];
    this.monthlyExpensesPerItem.forEach(yearData => {
      console.log(`getMonthlyExpensesPerItem, yearData: ${JSON.stringify(yearData)}`);
      if (year in yearData) {
        yearData[year].forEach(monthData => {
          console.log(`getMonthlyExpensesPerItem, monthData: ${JSON.stringify(monthData)}`);
          if (month in monthData) {
            console.log(`getMonthlyExpensesPerItem, month: ${JSON.stringify(month)}`);
            filteredData = monthData[month];
          }
        });
      }
    });
    return filteredData;
  }
  // End of filter monthly expenses per item by year and month

  calculateTotalMonthly() {
    // const filteredData = this.filterDataByYearAndMonth(year, month);
    let totalMonthly = 0;
    this.filteredMonthlyExpensesPerItem.forEach(item => {
      totalMonthly += item.total;
    });
    return totalMonthly;
  }

  exportMonthlyExpensesPerItemReport() {
    this.petService.exportMonthlyExpensesPerItemToExcel().subscribe((data: any) => {
      this.saveFile(data, 'monthly_expenses_per_item_reports.xlsx');
    });
  } // End of exportMonthlyExpensesPerItemReport

  private saveFile(data: any, filename: string) {
    const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } // End of saveFile

  closeModal() {
    this.hideModal(false);
  } // end of closeModal

  hideModal(result: boolean) {
    this.onClose.next(result);
    this.bsModalRef.hide();
  } // end of hideModal
}
